import React, { Component } from 'react';
class AgReportsContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b >  Reports:</b></p>
                <p>As a Agency , user can view a reports generated by the admin.</p>
                <p ><b > 1. Agency Commission Report:</b></p>
                <p>Reports Contains Commission Details of agency. Commission amount is displayed based on the run parameters. Eg Commission calculated for month Feb 2021.</p>
                <p ><b > 2.Agency Outstanding Payment Report:</b></p>
                <p>Reports Contains Outstanding payment details of agency. Outstanding amount is displayed based on the run parameters. Eg Outstanding payment  for month Feb 2021.</p>
                <p ><b > 3. Agency Enrollment Report:</b></p>
                <p>Report Contains members enrolled under agency . Members are listed based on the run paramerter Eg: Members enrolled for month Feb 2021.</p>
            </div>
        )
    }
}
export default AgReportsContent;
